import React, { ReactElement, useCallback } from 'react'
import { useRecoilValue } from 'recoil'
import { accountState, useRefreshAccountData } from '../../states/account-state'
import moment from 'moment'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router'

interface Props {
  readonly id: string
}

const Component = (props: Props): ReactElement | null => {
  const { id } = props

  const account = useRecoilValue(accountState(id))
  const updateAccount = useRefreshAccountData(id)
  const navigate = useNavigate()

  const onPress = useCallback(() => {
    navigate(`/manager/accounts/${id}`)
  }, [])

  return (
    <tr onClick={onPress} className="cursor-pointer">
      <td>
        <span className="font-semibold">{account?.name}</span>
      </td>
      <td>
        {parseFloat(String(account?.totalDepositsValue)).toFixed(2)}{' '}
        {account?.primaryCurrency?.code}
      </td>
      {/*<td>Standard</td>*/}
      {/*<td>0.00 %</td>*/}
      {/*<td>N/A</td>*/}
      {/*<td>{moment(item.openedAt).format('YYYY-MM-DD HH:mm')}</td>*/}
      <td>{moment(account?.updatedAt).format('YYYY-MM-DD HH:mm')}</td>
      <td>
        <button className="btn btn-sm btn-outline btn-primary" onClick={updateAccount}>
          Refresh
        </button>
      </td>
    </tr>
  )
}

export const AccountListItem = React.memo(Component)